export default "__VITE_ASSET__Ciyv7VN1__"